import { identity } from 'lodash';
import { get, put, post, del } from 'redux/shelf/api';
import { field } from 'redux/shelf';
import { success } from 'redux/shelf/actions';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';
import { mapBackendFilters } from './helpers';

export const actions = {
  getConfig: get`settings/${session.getMerchant}/frontend`(),
  update: put`recommendations/${session.getMerchant}/:id`(),
  fetch: get`recommendations/${session.getMerchant}/:id`((r) => ({
    entity: {
      ...r,
      filters: mapBackendFilters(r.filters),
    },
  })),
  create: post`recommendations/${session.getMerchant}`(),
  delete: del`recommendations/${session.getMerchant}/:id`(),
  getFields: get`fields/${session.getMerchant}`(identity), // res: { fields: [] }
  fetchCtr: get`analytics/reports/recommendation_ctr?from=:from&to=:to`(
    field('ctr')
  ),
  fetchList: get`recommendations/${session.getMerchant}`(),
  fetchTemplate: get`recommendations/${session.getMerchant}/templates`(
    field('template')
  ),
  updateTemplate: put`recommendations/${session.getMerchant}/templates/:id`(),
  fetchAvailableFallbacks:
    get`recommendations/${session.getMerchant}/available-fallbacks/:type`(),
  fetchAvailableFallbacksForRec:
    get`recommendations/${session.getMerchant}/:id/available-fallbacks/:type`(),
};

export const reducer = createReducer(
  [
    actions.fetch,
    actions.update,
    actions.create,
    actions.getFields,
    actions.fetchCtr,
    actions.fetchList,
    actions.fetchTemplate,
    actions.fetchAvailableFallbacks,
    actions.fetchAvailableFallbacksForRec,
  ],
  {
    [actions.fetchAvailableFallbacks]: (s, { payload }) => ({
      ...s,
      availableFallbacks: payload.entities,
    }),
    [actions.fetchAvailableFallbacksForRec]: (s, { payload }) => ({
      ...s,
      availableFallbacks: payload.entities,
    }),
  }
);
